var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scan-code-bg"})
}
var staticRenderFns = []

export { render, staticRenderFns }